import Settings from "../domain/Settings";

export function init(): void {
	const settings = Settings.getInstance().nativeTemplates;

	if (!settings) {
		return;
	}

	const renderConfig = JSON.parse(JSON.stringify(settings.renderConfig));

	if (settings.darkModeType === 'nunl') {
		try {
			renderConfig.darkMode = JSON.parse(window.localStorage.getItem('NU.theme'))?.data === 'dark';
		} catch (e) {
			console.warn('[ADVERT] Could not read NU.theme. Defaulting to light mode.', e);
		}
	}

	window.advert.nativeTemplates = Object.assign({}, window.advert.nativeTemplates, {renderConfig});
}
